// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"Qg-z","modalContent":"Rg-z","header":"Sg-z","close":"Tg-z"};